import { ChangeEvent } from "react";
import { Button, Input, InputGroup } from "reactstrap";
import { QuantityText } from "../../../../../../constants";
import { QuantityProp } from "../../../../../../types/Ecommerce";

// This component allows users to adjust a numerical quantity using buttons and an input field.
const Quantity: React.FC<QuantityProp> = ({ quantity, setQuantity }) => {

  const minusQty = () => quantity > 1 && setQuantity(quantity - 1);
  const plusQty = () => quantity >= 1 && setQuantity(quantity + 1);
  const changeQty = (e: ChangeEvent<HTMLInputElement>) => setQuantity(parseInt(e.target.value));

  return (
    <>
      <h5>{QuantityText}</h5>
      <fieldset className="border-0 m-0 p-0 w-50">
        <InputGroup className="bootstrap-touchspin">
          <Button color="primary" className="btn-square bootstrap-touchspin-down w-25 p-2" onClick={minusQty}>
            <i className="fa fa-minus text-white"></i>
          </Button>
          <Input className="touchspin text-center" type="text" name="quantity" value={quantity} onChange={(e) => changeQty(e)} />
          <Button color="primary" className="btn-square bootstrap-touchspin-up rounded-0 w-25 p-2" onClick={plusQty}>
            <i className="fa fa-plus text-white"></i>
          </Button>
        </InputGroup>
        <br />
      </fieldset>
    </>
  );
};
export default Quantity;